/**
 * Identifies the Confirmation transaction type.
 * tag: 666
 * @readonly
 * @enum {number} (int)
 */
export enum ConfirmTransType {
  /** New */
  New = 0,
  /** Replace */
  Replace = 1,
  /** Cancel */
  Cancel = 2,
}
